import React from 'react'
import { useSelector } from 'react-redux'
import { CustomizerContext } from './context/CustomizerContext'
import SiteBuilder from './modules/SiteBuilder'
import {useSharedDocument } from './hooks/documentHooks'
import AlertsBar from './components/AlertsBar'
import { BrowserRouter } from 'react-router-dom'
import SwitchSiteModal from './components/SwitchSiteModal'

const App = () => {
  const currentSite = useSelector(state => state.site)
  const [document, documentWebSocket, documentReady] = useSharedDocument(currentSite?.site_id, { ws: process.env.REACT_APP_WEBSOCKET })
  
  return (
    <CustomizerContext.Provider value={{ document, documentWebSocket, documentReady }}>
      <BrowserRouter>
        <SiteBuilder />
        <SwitchSiteModal />
        <AlertsBar />
      </BrowserRouter>
    </CustomizerContext.Provider>
  )
}

export default App
